import React from "react";
import { TreePine, Sparkles, Hourglass } from "lucide-react";

const FOREST_IMG =
  "https://images.unsplash.com/photo-1440581572325-0bea30075d9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxmb3Jlc3QlMjBzdW5saWdodCUyMHRyZWVzfGVufDB8fHx8MTc4MDM1MTkzOHww&ixlib=rb-4.1.0&q=85";

export default function EducationSection() {
  return (
    <section id="how-it-works" data-testid="education-section" className="py-24 lg:py-32 bg-[#F0EFEA]/40 border-y border-[#E5E2DC]">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <img
            src={FOREST_IMG}
            alt="Long-term growth"
            className="rounded-2xl border border-[#E5E2DC] aspect-[4/5] object-cover w-full"
          />
        </div>
        <div className="lg:col-span-7">
          <div className="text-[11px] tracking-[0.22em] uppercase text-[#5C6B62] font-semibold">methodology</div>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-[#1C2B23]">
            Real markets. Honest math.
          </h2>
          <p className="mt-5 text-[#5C6B62] leading-relaxed max-w-2xl">
            Most calculators bake in a flat 7% return. We don't. We pull the last 12 months of returns
            on the S&P 500, NASDAQ, Dow, international stocks, bonds, and gold — measure their actual
            mean and volatility — then blend that with century-long historical data to project your
            portfolio forward.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-6">
            <div className="p-5 rounded-xl bg-white border border-[#E5E2DC]">
              <Sparkles className="text-[#2B5339]" size={20} />
              <div className="font-display text-lg mt-3 text-[#1C2B23]">Live blended returns</div>
              <p className="text-sm text-[#5C6B62] mt-2 leading-relaxed">
                50% live trailing-year data, 50% long-run historical priors — both volatility and mean.
              </p>
            </div>
            <div className="p-5 rounded-xl bg-white border border-[#E5E2DC]">
              <Hourglass className="text-[#2B5339]" size={20} />
              <div className="font-display text-lg mt-3 text-[#1C2B23]">Up to age 100</div>
              <p className="text-sm text-[#5C6B62] mt-2 leading-relaxed">
                Whether you set life expectancy to 85 or 120, we project every year of your portfolio's life.
              </p>
            </div>
            <div className="p-5 rounded-xl bg-white border border-[#E5E2DC]">
              <TreePine className="text-[#2B5339]" size={20} />
              <div className="font-display text-lg mt-3 text-[#1C2B23]">1,500 simulations</div>
              <p className="text-sm text-[#5C6B62] mt-2 leading-relaxed">
                We don't show one rosy line. We run thousands and show you the 10th, 50th, and 90th percentiles.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
